import { LogLevel } from '@azure/msal-browser';

export const b2cPolicies = {
    names: {
        signUpSignIn: 'B2C_1_SIGNIN'
    },
    authorities: {
        signUpSignIn: {
            authority: 'https://goderjb2c.b2clogin.com/goderjb2c.onmicrosoft.com/B2C_1_SIGNIN',
        }
    },
    authorityDomain: 'goderjb2c.b2clogin.com',
};

export const msalConfigB2c = {
    auth: {
        clientId: '0dfc7fb7-50e8-4ee8-b71e-e494620e889e', 
        authority: b2cPolicies.authorities.signUpSignIn.authority, 
        knownAuthorities: [b2cPolicies.authorityDomain], 
        redirectUri: "https://safelog.godrejenterprises.com/redirect",//new 
        // redirectUri: 'https://safelog.godrej.com/redirect', 
        // redirectUri: 'http://localhost:3000/redirect', 
        postLogoutRedirectUri: '/',
        navigateToLoginRequestUrl: false, 
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            logLevel:LogLevel.Verbose,
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            },
        },
    },
};


/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequestB2c = {
    scopes: ["openid", "profile","email"],
};
